import { useState, useCallback } from "react"
import chevronIcon from "icons/chevron.svg"
import { classes } from "utils"
import { colors } from "design"
import { Layout } from "./layout.js"
import { typography } from "design"

export const accordionVariablesLight = {
  "--resbird-accordion-icon-background": colors.blueGrey,
  "--resbird-accordion-border-color": colors.grey600,
  "--resbird-accordion-heading-color": colors.grey500,
}

export const Accordion = ({
  className,
  heading,
  subheading,
  onClick,
  children,
  headingStyle,
  startExpanded,
  ...props
}) => {
  const [expanded, setExpanded] = useState(startExpanded)

  const onExpandCollapse = useCallback(() => {
    setExpanded((prev) => !prev)
    onClick?.()
  }, [onClick])

  return (
    <section
      className={classes(className, "accordion")}
      css={{
        width: "100%",
        border: "1px solid",
        borderColor: "var(--resbird-accordion-border-color)",
        borderRadius: 4,
      }}
      {...props}
    >
      <Layout
        css={[
          { justifyContent: "space-between", padding: "10px 40px" },
          headingStyle,
        ]}
        horizontal
      >
        <Layout
          className="accordion-heading"
          css={{ gap: 10, color: 'var("--resbird-accordion-heading-color")' }}
          horizontal
        >
          <h2
            className="accordion-heading"
            css={typography.accordionTitle}
          >
            {heading}
          </h2>
          {subheading && (
            <h3
              className="accordion-sub-heading"
              css={{
                textTransform: "uppercase",
                fontWeight: "normal",
                fontStyle: "italic",
              }}
            >
              {subheading}
            </h3>
          )}
        </Layout>
        <div
          className="accordion-icon-button"
          css={[
            {
              width: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              justifyContent: "center",
              borderRadius: "50%",
              background: "var(--resbird-accordion-icon-background)",
            },
            expanded && { transform: "rotate(180deg)" },
          ]}
          role="button" // Declare as a button for screen readers
          tabIndex="0" // Make it focusable for keyboard users
          aria-expanded={expanded} // Indicate the expanded state
          onClick={onExpandCollapse}
        >
          <img src={chevronIcon} />
        </div>
      </Layout>
      {expanded && children}
    </section>
  )
}
